import type {
  CreateTenantRequest,
  TenantDeactivationImpact,
  TenantView,
  UpdateTenantActiveRequest,
} from '../../services/tenants/tenants.service';
import type { ToggleTenantImpact } from './tenants-page.types';

export const normalizeCompanyName = (companyName: string): string => companyName.trim();

export const buildCreateTenantPayload = (companyName: string): CreateTenantRequest => ({
  companyName: normalizeCompanyName(companyName),
});

export const buildToggleTenantImpact = (
  tenant: TenantView,
  impact: TenantDeactivationImpact,
): ToggleTenantImpact => ({
  title: `להשבית את החברה "${tenant.companyName}"?`,
  lines: [
    `משתמשים פעילים מושפעים: ${impact.affectedUserCount}`,
    `משתמשים שיושבתו: ${impact.usersWillDeactivateCount}`,
    `משתמשים שתחלף חברתם הראשית: ${impact.usersPrimaryWillSwitchCount}`,
  ],
});

export const buildToggleActivePayload = (tenant: TenantView): UpdateTenantActiveRequest => ({
  isActive: !tenant.isActive,
});

export const addUpdatingTenantId = (updatingIds: number[], tenantId: number): number[] =>
  updatingIds.includes(tenantId) ? updatingIds : [...updatingIds, tenantId];

export const removeUpdatingTenantId = (updatingIds: number[], tenantId: number): number[] =>
  updatingIds.filter((id) => id !== tenantId);

export const toggleExpandedTenant = (
  currentExpandedTenantId: number | null,
  nextTenantId: number,
): number | null => (currentExpandedTenantId === nextTenantId ? null : nextTenantId);
